module.exports = __webpack_public_path__ + "static/media/4-motivation.34e0ae61.svg";